// Datas de calendário: não converter o ISO para horário local, pois isso pode
// deslocar o primeiro dia do mês para o mês anterior.
const mesCalendario = valor => {
  const texto = valor instanceof Date && !Number.isNaN(valor.getTime()) ? valor.toISOString() : String(valor || '');
  const match = texto.match(/^(\d{4})-(\d{2})-(\d{2})(?:T|$)/);
  if (!match) return '';
  const [, ano, mes, dia] = match;
  const data = new Date(`${ano}-${mes}-${dia}T12:00:00Z`);
  if (Number.isNaN(data.getTime()) || data.getUTCFullYear() !== Number(ano) || data.getUTCMonth() + 1 !== Number(mes) || data.getUTCDate() !== Number(dia)) return '';
  return `${ano}-${mes}`;
};

export const classificarPromissorias = (negociacao = {}) => {
  const promissorias = (negociacao.recebimentos || []).filter(recebimento =>
    String(recebimento?.tipo || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim().toLowerCase() === 'nota promissoria'
  );
  const referencia = mesCalendario(negociacao.data);
  const meses = promissorias.flatMap(recebimento => (recebimento.promissoria?.parcelas || [])
    .map(parcela => mesCalendario(parcela?.vencimento)).filter(Boolean));
  const noMes = Boolean(referencia && meses.some(mes => mes === referencia));
  const posteriores = Boolean(referencia && meses.some(mes => mes > referencia));
  return {
    noMes,
    posteriores,
    // Preserva a identificação de promissórias ainda sem programação válida,
    // mas não afirma que vencem neste mês nem inventa datas para as parcelas.
    semPeriodo: promissorias.length > 0 && !noMes && !posteriores
  };
};
